export default __webpack_public_path__ + "static/media/330_business02-jp-web.b7f42752.png";